export class OldConditionReportVersionFetchedError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "OldConditionReportVersionFetchedError"
    }
}